import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import BotIcon from '@cp/src/assets/icons/BotIcon';
import { GenAiCocViolation, ViolatingUtterance } from '../../interface';
import AgentCircularIcon from '@cp/src/assets/icons/AgentCircularIcon';
import CustomerBorderIcon from '@cp/src/assets/icons/CustomerBorderIcon';
import { UtternceType } from '../auditEnums';

interface AiAuditSummarySectionProps {
  violations: GenAiCocViolation[];
}

const UtteranceBubble = ({ utterance }: { utterance: ViolatingUtterance }) => {
  const isAgent = utterance.speaker?.toUpperCase() === UtternceType.AGENT;
  const Icon = isAgent ? (
    <div className="flex flex-col justify-between items-center bg-[var(--bg-primary)] p-3">
      <AgentCircularIcon
        fillColor2="var(--bg-primary)"
        fillColor="var(--grayscale-2)"
        fillColor1="var(--bg-primary)"
        width={24}
        height={24}
      />
      <Typography variant="p5" color="var(--grayscale-2)" className="!text-[9px]">
        Agent
      </Typography>
    </div>
  ) : (
    <div className="flex flex-col justify-between items-center bg-[var(--bg-primary)] p-1">
      <CustomerBorderIcon fillColor="var(--blue-base)" />
      <Typography variant="p5" color="var(--grayscale-2)" className="!text-[9px]">
        Customer
      </Typography>
    </div>
  );

  return (
    <div className="flex items-start gap-2.5 px-3 py-2 rounded-lg bg-[var(--bg-secondary)]">
      <Typography variant="h4" color="var(--red-crisis)" className="flex-1">
        {utterance.text}
      </Typography>
      <div className="flex-shrink-0 mt-0.5">{Icon}</div>
    </div>
  );
};

const AiAuditSummarySection = ({ violations }: AiAuditSummarySectionProps) => {
  if (!violations?.length) return null;

  return (
    <div className="flex flex-col min-h-0 flex-1">
      <div className="flex items-center gap-1 px-4 py-2 bg-[var(--bg-dark)] flex-shrink-0">
        <BotIcon width={20} height={20} fillColor="var(--bg-primary)" />
        <Typography variant="h4" color="var(--bg-primary)">
          AI audit summary
        </Typography>
      </div>

      <div className="flex flex-col gap-2.5 p-2 overflow-y-auto">
        {violations.map((violation, index) => (
          <div
            key={index}
            className="bg-[var(--bg-primary)] border border-solid border-[var(--greyscale-light)] rounded-[16px] p-2 flex flex-col gap-2"
          >
            <div className="flex gap-1 items-start">
              <Typography
                variant="h4"
                color="var(--grayscale-2)"
                className="w-5 text-center font-bold"
              >
                {index + 1}.
              </Typography>
              <Typography variant="h4" color="var(--grayscale-2)" className="flex-1 font-semibold">
                {violation.violation_type}
              </Typography>
            </div>
            <div className="pl-5">
              <Typography variant="p5" color="var(--greyscale-content-3)">
                {violation.explanation}
              </Typography>
            </div>
            {violation.violating_utterances?.map((utterance, uIndex) => (
              <UtteranceBubble key={uIndex} utterance={utterance} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AiAuditSummarySection;
